import { TableCell, TableRow } from "@material-ui/core";
import { memo } from "react";
import { emptyDescription } from "../../RankingClienteConstants";

const GroupHeaderTableRow = ({ cell, columns }) => {
  return (
    <TableRow>
      <TableCell
        align="left"
        colSpan={columns.length}
        style={{ backgroundColor: "#eaf2ff" }}
      >
        {cell.group?.description ?? emptyDescription[cell.group?.type]}
      </TableCell>
    </TableRow>
  );
};

export default memo(GroupHeaderTableRow);
